<script>
import toHTML from 'linkifyjs/html';

import { SectionPostTypes } from '../../constants';

export default {
  name: 'CpSharePostItem',
  data() {
    return {
      showLikesModal: false,
      comments_count: this.postShared.comments_count,
      showAuthModal: false,
      type: SectionPostTypes.POST_SHARED,
    };
  },
  directives: {
    margin: require('../../directives/margins').margin,
    marginBottom: require('../../directives/margins').marginBottom,
    marginTop: require('../../directives/margins').marginTop,
  },
  components: {
    PersonIcon: require('../icons').default,
    CpBaseSvgIcon: require('../../base-svg-icon').default,
    CpButtonLink: require('../../button-link').default,
    CpImage: require('../../image').default,
    CpSocialShareDialog: require('../../dialogs/social-share').default,
    LikeActionButton: require('../actions/like-action-button').default,
    CpLikesProfiles: require('../../likes/likes-profiles').default,
    CpDialog: require('../../dialog').default,
    CommentActionButton: require('../actions/comment-action-button').default,
    CpCommentsPost: require('../../comments/box-comments').default,
    CpSocialFeedCustomContent: require('./CustomContent').default,
    CpSocialFeedBlogPost: require('./blog-post').default,
    CpSocialFeedPetitionPost: require('./petition-post').default,
    CpSocialFeedNewsPost: require('./news-post').default,
    CpSocialFeedRacePost: require('./race-post').default,
    CpSocialFeedCandidatePost: require('./candidate-post').default,
    CpSocialFeedLobbyPost: require('./lobby-post').default,
    CpSearchResult: require('../../explore-campaigns/result').default, //Campaigns
    CpOpinionsItem: require('../../opinions/opinions-item').default,
    CpGrid: require('../../grid').default,
    CpGridItem: require('../../grid-item').default,
    CpSocialFeedPollPost: require('./poll-post').default,
    CpGroup: require('../../groups/group-card').default,
    CpEventCard: require('../../events/event-card.vue').default,
    CpSocialFeedLivestreamPost: require('./livestream-post').default,
    CpDialogAuthForm: require('../../auth-form/dialog-auth-form').default,
    CpCardHeaderReactions: require('../../components/CardHeaderReactions').default,
    CpShowInteractionsCount: require('../../components/ShowInteractionsCount').default,
  },
  props: {
    postShared: { type: Object, default: () => {} },
    like: [Object, Boolean],
    comment: [Object, Boolean],
    resultsUrlSuffix: [String, Boolean],
  },
  methods: {
    profile(slug) {
      return '/profile/' + slug;
    },
    handleLikesModal() {
      this.showLikesModal = !this.showLikesModal;
    },
    handleCountLikes(value) {
      value ? (this.postShared.likes_count = this.postShared.likes_count + 1) : (this.postShared.likes_count = this.postShared.likes_count - 1);
    },
    setCommentsCount(action) {
      action == 'remove' ? this.comments_count-- : this.comments_count++;
    },
  },
  computed: {
    authUser() {
      return this.$root.authUser;
    },
    content() {
      return toHTML(this.postShared.comment);
    },
  },
};
</script>

<template>
  <div class="social-feed-post-wrapper">
    <!-- TO DO: uncomment this when we implement the new feed logic -->
    <!-- <div v-if="postShared.last_activity" style="display: flex">
      <CpCardHeaderReactions :post="postShared.last_activity" />
    </div>
    <hr v-if="postShared.last_activity" class="search-results__tick_action" /> -->

    <div class="social-feed-post-profile-wrapper">
      <a class="profile-img social-feed-default-img" style="margin-right: 5px" :href="profile(postShared.owner.slug)">
        <cp-image
          class="user-image"
          :src="postShared.owner.profile_image"
          circular
          :width="$root.isMobile ? '25' : '40'"
          :height="$root.isMobile ? '25' : '40'"
          style="position: initial"
        ></cp-image>
      </a>

      <span class="mini-recipient">
        <span>
          <a class="subheadline1 neutral6-color" :href="profile(postShared.owner.slug)">{{ postShared.owner.name }}</a>
          <span class="body neutral4-color">{{ ' ' }}shared this post.</span>
        </span>
      </span>
    </div>
    <div>
      <div v-if="postShared.comment" class="description" v-html="content" />
      <CpSocialFeedCustomContent v-if="postShared.type_post == 'CustomContent'" :post="postShared.data_post" :for-share="true" />
      <cp-social-feed-blog-post v-if="postShared.type_post == 'Blog'" :blog="postShared.data_post" :for-share="true" />
      <cp-social-feed-petition-post v-if="postShared.type_post == 'Petition'" :petition="postShared.data_post" :for-share="true" :explore="true" />
      <cp-social-feed-news-post v-if="postShared.type_post == 'News'" :news="postShared.data_post" :for-share="true" />
      <cp-social-feed-race-post v-if="postShared.type_post == 'Election'" :race="postShared.data_post" :for-share="true" />
      <cp-search-result v-if="postShared.type_post == 'Crowdpac'" :result="postShared.data_post" :for-share="true" :results-url-suffix="resultsUrlSuffix" />
      <cp-opinions-item v-if="postShared.type_post == 'StatusPost'" :data="postShared.data_post" :type="'opinion'" :for-share="true" :explore="true" />
      <cp-opinions-item v-if="postShared.type_post == 'GroupOpinion'" :data="postShared.data_post" :type="'groups'" :for-share="true" :explore="true" />
      <cp-social-feed-candidate-post
        v-if="postShared.type_post == 'Candidate'"
        :candidate="postShared.data_post"
        :for-share="true"
        :explore="true"
        :iconState="true"
      />
      <cp-social-feed-lobby-post v-if="postShared.type_post == 'Lobby'" :lobby="postShared.data_post" :for-share="true" :explore="true" :iconState="true" />
      <cp-social-feed-poll-post v-if="postShared.type_post == 'Poll'" :poll="postShared.data_post" :for-share="true" :explore="true" />
      <cp-group v-if="postShared.type_post == 'Group'" :group="postShared.data_post" :for-share="true" :explore="true" />
      <div v-if="postShared.type_post == 'GroupEvent'">
        <cp-social-feed-livestream-post
          v-if="postShared.data_post.archive_url && postShared.data_post.status == 'shared'"
          :data="postShared.data_post"
          :playback="postShared.data_post.archive_url"
          :title="postShared.data_post.title"
          :type="postShared.data_post.video_type == 'events' ? 'event' : postShared.data_post.type"
          :for-share="true"
          :explore="true"
        />
        <cp-event-card v-else :event="postShared.data_post" :for-share="true" />
      </div>
      <cp-social-feed-livestream-post
        v-if="postShared.type_post == 'Livestream'"
        :data="postShared.data_post"
        :playback="postShared.data_post.archive_url"
        :title="postShared.data_post.title"
        :type="postShared.data_post.video_type == 'events' ? 'event' : postShared.data_post.type"
        :for-share="true"
        :explore="true"
      />
    </div>

    <div style="margin-top: 10px !important">
      <CpShowInteractionsCount
        :type="type"
        :id="postShared.id"
        :likesCount="postShared.likes_count"
        :commentsCount="comments_count"
        :handleLikesModal="handleLikesModal"
      />
    </div>

    <cp-dialog v-if="showLikesModal">
      <cp-likes-profiles :count-likes="postShared.likes_count" :id="parseInt(postShared.id)" :type="'post_shared'" @close="handleLikesModal">
      </cp-likes-profiles>
    </cp-dialog>

    <div class="social-feed-post-actions">
      <div class="post-action-button like">
        <like-action-button type="post_shared" :id="postShared.id" :liked="postShared.liked" :onSuccess="handleCountLikes" />
      </div>
      <div class="post-action-button comment">
        <comment-action-button :type="type" :id="postShared.id" />
      </div>
    </div>

    <cp-comments-post :id="postShared.id" :type="type" :setCount="setCommentsCount">
    </cp-comments-post>
  </div>
</template>

<style scoped>
.search-results__tick_action {
  width: 50px !important;
  margin-right: auto;
}
div.social-feed-post-profile-wrapper {
  display: flex;
  flex-direction: row;
}
div.social-feed-post-profile-wrapper .details-wrapper {
  display: flex;
  flex-direction: column;
  padding-left: 10px;
}

div.social-feed-post-profile-wrapper .profile-name {
  font-size: 1.3em;
  font-weight: 600;
  padding-bottom: 5px;
  padding-right: 5px;
  margin: 1px;
}

div.social-feed-post-profile-wrapper .post-time {
  font-size: 0.9em;
  color: #666;
  font-weight: 400;
  margin-right: 20px;
}

img.social-feed-post-img {
  max-width: 100%;
  max-height: 100%;
  min-width: 100%;
}
span.social-feed-default-img {
  display: flex;
  align-items: center;
  justify-content: center;
}
a.social-feed-post-link {
  display: block;
  padding-top: 10px;
  font-size: 1.1em;
}

div.social-feed-post-wrapper {
  width: 100%;
  padding: 1em;
  border-bottom: 2px solid var(--neutral3);
  margin-bottom: 1.5em;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: auto;
}
div.social-feed-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.social-feed-post-wrapper > * {
  width: 100%;
}

.mini-recipient__subtitle {
  margin-top: 0px;
}

div.social-feed-box-wrapper.mobile img.social-feed-post-img {
  min-height: 45vh;
  object-fit: cover;
}
.social-feed-default-img {
  background: none;
  color: var(--highlight);
}
div.social-feed-box-wrapper.mobile div.social-feed-post-wrapper {
  padding: 0.7em;
}
div.social-feed-post-img-placeholder {
  min-height: 400px;
  background: rgb(233, 94, 54);
  background: linear-gradient(180deg, rgba(233, 94, 54, 1) 65%, rgba(254, 130, 94, 1) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}
header.social-feed-title-header {
  text-align: center;
  margin: 30px 0px;
}
div.social-feed-post-description {
  padding-top: 10px;
}
video.candidate-video-player {
  width: 100%;
  height: auto;
}
.profile-img {
  height: unset;
  width: unset;
}
.profile-img.social-feed-default-img svg {
  margin-top: 10px;
}

.social-feed-sidebar {
  position: fixed;
}

.header-label {
  font-size: 16px;
  font-family: 'proxima-nova', Gotham, Helvetica, sans-serif;
  font-weight: 600;
  color: #121212;
}

.mobile-fixed-bottom-sidebar .social-feed-right-sidebar {
  padding: 15px;
  position: relative;
  max-width: 100% !important;
}

.small-desktop-right-sidebar .social-feed-right-sidebar {
  max-width: 12.2vh;
}

.small-desktop-right-sidebar .title-3 hr {
  display: none;
}

.mobile-fixed-bottom-sidebar {
  position: fixed;
  background: white;
  width: 100% !important;
  bottom: 0px;
  left: 0px;
  margin: 0px;
}
.search-results__tick_like {
  color: #cacaca;
  width: 50px;
}
.description {
  font-family: inherit;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 1.6;
  margin: 0px !important;
  padding-top: 5px;
  padding-bottom: 5px;
  color: #000000;
}
.title {
  font-weight: bold;
  font-size: 25px;
  color: #000000;
  margin: 0px !important;
}
.image {
  border-radius: 5px;
  width: 100%;
  box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.2);
  margin: 0px 0px 0px 0px;
}
.video {
  border-radius: 5px;
  box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.2);
  max-width: 100%;
  height: auto;
}
.image-mobile {
  border-radius: 5px;
  max-height: 400px;
  max-width: 100%;
  width: auto;
  box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.2);
  margin-top: 10px;
}
</style>
